{
    "training": [
        "Medical Student",
        "Intern or Resident",
        "Registrar",
        "Fellow",
        "Consultant",
        "Other"
    ],
    "specialties": [
        ["Addiction Medicine", "Drug & Alcohol Medicine"],
        ["Anaesthetics", "Anaesthesia"],
        "Breast/Endocrine Surgery",
        "Cardiology",
        "Cardiothoracic Surgery",
        "Child and Adolescent Psychiatry",
        "Clinical Research",
        "Critical Care Medicine",
        "Dermatology",
        "Disability Health",
        ["Emergency Medicine", "ED"],
        "Endocrinology",
        "Gastroenterology",
        "Gastrointestinal Surgery",
        "General Medicine",
        ["General Practice", "GP"],
        "General Surgery",
        "Genetics",
        ["Geriatrics", "Geris"],
        "Gynaecology",
        "Haematology",
        "Hepatobiliary Surgery",
        "Hepatology",
        "Immunology",
        "Indigenous Health",
        ["Infectious Diseases", "ID"],
        ["Intensive Care Medicine", "ICU"],
        "Medical Administration",
        "Neonatology",
        ["Nephrology", "Renal"],
        "Neurology",
        "Neurosurgery",
        ["OMS/Dental", "Oral and Maxillofacial Surgery OMFS"],
        "Obstetrics",
        "Occupational/Environmental Medicine",
        "Oncology",
        "Ophthalmology",
        "Orthopaedics",
        ["Otorhinolaryngology", "ENT"],
        "Paediatric Medicine",
        "Paediatric Orthopaedics",
        "Paediatric Surgery",
        "Paediatrics",
        "Pain Medicine",
        "Palliative Care",
        "Pathology",
        "Perioperative Medicine",
        "Pharmacology",
        "Plastic Surgery",
        "Psychiatry",
        "Public Health",
        "Radiology",
        "Rehabilitation Medicine",
        ["Respiratory Medicine", "Pulmonology"],
        "Rheumatology",
        "Rural & Remote Medicine",
        "Sexual Health",
        "Sports Medicine",
        "Toxicology",
        "Trauma Surgery",
        "Urology",
        "Vascular Surgery",
        "Women’s Health"
    ],
    "exams": [
        {
            "label": "Medical School",
            "options": ["Written Exams", "OSCEs"],
            "students": true
        },
        {
            "label": "International Medical Graduates",
            "options": ["AMC MCQ", "AMC Clinical", "AMC WBA Pathway"],
            "students": false
        },
        {
            "label": "General Practice",
            "options": ["ACRRM MCQ", "ACRRM StAMPS", "RACGP AKT/KFP", "RACGP CCE"],
            "students": false
        },
        {
            "label": "Emergency Medicine",
            "options": ["ACEM Primary", "ACEM Fellowship"],
            "students": false
        },
        {
            "label": "Anaesthesia",
            "options": ["ANZCA Primary", "ANZCA Final"],
            "students": false
        },
        {
            "label": "Intensive Care Medicine",
            "options": ["CICM First Part", "CICM Second Part"],
            "students": false
        },
        {
            "label": "Obstetrics & Gynaecology",
            "options": ["FRANZCOG Written", "CWH/PTP Written"],
            "students": false
        },
        {
            "label": "Surgery",
            "options": ["GSSE"],
            "students": false
        },
        {
            "label": "General Medicine",
            "options": ["RACP Adult DWE"],
            "students": false
        },
        {
            "label": "Paediatrics",
            "options": ["RACP Paediatrics DWE"],
            "students": false
        },
        {
            "label": "Radiology",
            "options": ["RANZCR Phase 1", "RANZCR Phase 2"],
            "students": false
        },
        {
            "label": "Pathology",
            "options": ["RCPA BPS"]
        }
    ]
}
